export const MAIN_API = 'https://localhost:44329/'; //'https://mv-api.azurewebsites.net/'
export const SPINNER_TEMPLATE = "<img src='assets/images/logos/mv_logo_100-100.gif'/>";
export const supportedFileUploadTypes = [ '.jpg', '.png', '.jpeg', '.gif', '.pdf', '.doc', '.xls', '.rar', '.zip' ];

export const entityTypes = [
    {
        id: 'Individual_entrepreneur',
        description: 'ENI',
        invariantCultureDescription: 'Individual Entrepreneur',
        icon: 'fa-user-tie'
    },
    {
        id: 'Company',
        description: 'Empresa',
        invariantCultureDescription: 'Company',
        icon: 'fa-building'
    },
    {
        id: 'Private',
        description: 'Particular',
        invariantCultureDescription: 'Private',
        icon: 'fa-user'
    }
]

// Id's are related to the environment variable and not the actual GUID
export const contractTypes = [
    {
        id: 'Business',
        invariantCultureDescription: 'Business',
        icon: 'fa-building'
    },
    {
        id: 'Personal',
        invariantCultureDescription: 'Personal',
        icon: 'fa-user'
    }
]

export enum ContactTypes {
    CLIENT_PORTAL = '1A7AD712-29F3-4AD4-BA8F-E5146ACB5715'
}

export const electricityAllowedConsumptions: { [key: string]: any } = {
    'BTN': {
        'SIMPLES': {
            consumptionTypes: {
                'PT': new Map([['PEAK', 'peak']]),
                'ES': new Map([['PEAK', 'peak']])
            },
            energyPrices: {
                'PT': new Map([['PEAK', 'peakEnergyPrice']]),
                'ES': new Map([['PEAK', 'peakEnergyPrice']])
            },
        },
        'BIHOURLY': {
            consumptionTypes: {
                'PT': new Map([['OFF_PEAK', 'offPeak'], ['PEAK', 'peak']]),
                'ES': new Map([['OFF_PEAK', 'offPeak'], ['PEAK', 'peak']])
            },
            energyPrices: {
                'PT': new Map([['OFF_PEAK', 'offPeakEnergyPrice'], ['PEAK', 'peakEnergyPrice']]),
                'ES': new Map([['OFF_PEAK', 'offPeakEnergyPrice'], ['PEAK', 'peakEnergyPrice']])
            },
        },
        'TRIHOURLY': {
            consumptionTypes: {
                'PT': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard']]),
                'ES': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard']])
            },
            energyPrices: {
                'PT': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice']]),
                'ES': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice']])
            },
        },
        'QUADHOURLY': {
            consumptionTypes: {
                'PT': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']]),
                'ES': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']])
            },
            energyPrices: {
                'PT': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']]),
                'ES': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']])
            },
            
        }
    },
    'BTE': {
        consumptionTypes: {
            'PT': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']]),
            'ES': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']])
        },
        energyPrices: {
            'PT': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']]),
            'ES': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']])
        },
    }
    ,
    'MT': {
        consumptionTypes: {
            'PT': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']]),
            'ES': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']])
        },
        energyPrices: {
            'PT': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']]),
            'ES': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']])
        },
    },
    'AT': {
        consumptionTypes: {
            'PT': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']]),
            'ES': new Map([['PEAK', 'peak'], ['OFF_PEAK', 'offPeak'], ['STANDARD', 'standard'], ['SUPER_OFF_PEAK', 'superOffPeak']])
        },
        energyPrices: {
            'PT': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']]),
            'ES': new Map([['PEAK', 'peakEnergyPrice'], ['OFF_PEAK', 'offPeakEnergyPrice'], ['STANDARD', 'standardEnergyPrice'], ['SUPER_OFF_PEAK', 'superOffPeakEnergyPrice']])
        },
    }
}

export const eletricityConsumptionTypesPT = [
    {
        key: 'OFF_PEAK',
        value: 'offPeak'
    },
    {
        key: 'PEAK',
        value: 'peak'
    },
    {
        key: 'STANDARD',
        value: 'standard'
    },
    {
        key: 'SUPER_OFF_PEAK',
        value: 'superOffPeak'
    }
]

export const eletricityConsumptionTypes_BTN_SimplePT = [
    {
        key: 'PEAK',
        value: 'peak'
    }
]

export const eletricityConsumptionTypes_BTNPT = [
    {
        key: 'OFF_PEAK',
        value: 'offPeak'
    },
    {
        key: 'PEAK',
        value: 'peak'
    },
    {
        key: 'STANDARD',
        value: 'standard'
    }
]

export const eletricityConsumptionTypesES = [
    {
        key: 'OFF_PEAK',
        value: 'offPeak'
    },
    {
        key: 'PEAK',
        value: 'peak'
    },
    {
        key: 'STANDARD',
        value: 'standard'
    },
    {
        key: 'SUPER_OFF_PEAK',
        value: 'superOffPeak'
    }
]

export const naturalGasConsumptionTypesPT = [
    {
        key: 'GAS',
        value: 'gas'
    }
]

export const naturalGasConsumptionTypesES = [
    {
        key: 'GAS',
        value: 'gas'
    }
]